import React from 'react'
import TransitionBanner from '../components/TransitionBanner'
import Header from '../components/Header'
import Hero from '../components/Hero'
import ProductProof from '../components/ProductProof'
import Features from '../components/Features'
import Messaging from '../components/Messaging'
import MobileApps from '../components/MobileApps'
import TenantTheming from '../components/TenantTheming'
import Pricing from '../components/Pricing'
import Testimonial from '../components/Testimonial'
import SignupBand from '../components/SignupBand'
import Footer from '../components/Footer'

const HomePage: React.FC = () => (
  <div className="min-h-screen">
    <TransitionBanner />
    <Header />
    <main>
      <Hero />
      <ProductProof />
      <Features />
      <Messaging />
      <MobileApps />
      <TenantTheming />
      <Pricing />
      <Testimonial />
      <SignupBand />
    </main>
    <Footer />
  </div>
)

export default HomePage
